import React from "react";
import { HOME_PLATFORMS } from "../data/homeDefaults";

// Font Awesome has no Kick icon, so the blocky K is drawn here.
function KickGlyph() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <polygon points="3,3 9,3 9,9 12,9 12,6 15,6 15,3 21,3 21,9 15,9 15,15 21,15 21,21 15,21 15,18 12,18 12,15 9,15 9,21 3,21" />
    </svg>
  );
}

const ICONS = {
  twitch: <i className="fab fa-twitch" aria-hidden="true" />,
  youtube: <i className="fab fa-youtube" aria-hidden="true" />,
  kick: <KickGlyph />,
};

export default function PlatformLogo({ platform }) {
  if (!ICONS[platform]) return null;
  return (
    <span className={`platform-logo platform-logo--${platform}`} title={HOME_PLATFORMS[platform]}>
      {ICONS[platform]}
      <span className="visually-hidden">{HOME_PLATFORMS[platform]}</span>
    </span>
  );
}
